import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=63cc5d81&scoped=true"
import script from "./Levels.vue?vue&type=script&lang=js"
export * from "./Levels.vue?vue&type=script&lang=js"
import style0 from "./Levels.vue?vue&type=style&index=0&id=63cc5d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc5d81",
  null
  
)

export default component.exports